import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { ConnectingVisitStatus } from "__generated__/enums";
import { intl } from "LocaleWrapper";

const ConnectingVisitStatusSelect = <Multiple extends boolean = false,>({
	...rest
}: Omit<SelectProps<ConnectingVisitStatus, Multiple>, "fetchOptions" | "paginated" | "disableSearch">) => {
	return (
		<Select
			fetchOptions={Object.values(ConnectingVisitStatus)}
			getOptionLabel={(option) => intl.formatMessage({ id: `CONNECTING_VISIT_STATUS_${option}` })}
			disableSearch
			{...rest}
		/>
	);
};

export default ConnectingVisitStatusSelect;
